import { render, staticRenderFns } from "./MenuFileMagnifyGlassFilled.vue?vue&type=template&id=6c03b5af"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports